import { compareFilterBarConfig } from './filterBars';

import type { LayoutPageConfig } from './types';

export const dashboardPageConfig = {
  namespacesRequired: ['dashboard', 'tables'],
  layout: {
    filterBar: compareFilterBarConfig,
  },
} satisfies LayoutPageConfig;
